import React from 'react';
import { ScoreProvider } from './components/ScoreContext';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { StickyWidget } from './components/StickyWidget';
import { Diagnostic } from './components/Diagnostic';
import { HeroV2 } from './components/v2/HeroV2';
import { BusinessPayoffV2 } from './components/v2/BusinessPayoffV2';
import { Gap } from './components/v2/Gap';
import { QuickCheck } from './components/v2/QuickCheck';
import { Solution } from './components/v2/Solution';
import { RevenueArchitecture } from './components/v2/RevenueArchitecture';
import { PrototypeProof } from './components/v2/PrototypeProof';
import { AuthorLeverage } from './components/v2/AuthorLeverage';
import { DoneForYou } from './components/v2/DoneForYou';
import { FitInvestment } from './components/v2/FitInvestment';
import { ScoreAuditBuild } from './components/v2/ScoreAuditBuild';
import { FaqFinalCta } from './components/v2/FaqFinalCta';
export function AppV2() {
  return <ScoreProvider data-id="element-16" data-mp="7vbt1gxyfykj">
      <div className="min-h-screen bg-paper font-sans text-text selection:bg-seaglass selection:text-white" data-id="element-17" data-mp="7vtxh0urtj3j">
        <Nav data-id="element-18" data-mp="ctlq5x38p98s" />
        <main data-id="element-19" data-mp="cx9jow8opvni">
          <HeroV2 data-id="element-20" data-mp="hujfquqkx5kb" />
          <BusinessPayoffV2 data-id="element-21" data-mp="htzvh7dgi534" />
          <Gap data-id="element-22" data-mp="hvuhkp0gs38s" />
          <QuickCheck questionId="q2.intent.handRaiserContext" checkLabel="Quick Check" confirmationText="Saved. This is part of your Reader-to-Revenue Score." data-id="element-23" data-mp="hvaz976wjcu8" />
          <Solution data-id="element-24" data-mp="3lcb3ty1lh5d8" />
          <RevenueArchitecture data-id="element-25" data-mp="3lct8nj2borwr" />
          <PrototypeProof data-id="element-26" data-mp="3l9f5w9pqygos" />
          <AuthorLeverage data-id="element-27" data-mp="3q9tg9yetm2pz" />
          <DoneForYou data-id="element-28" data-mp="3qb4ku0g3bei5" />
          <FitInvestment data-id="element-29" data-mp="3q88kk5grsdqj" />
          <ScoreAuditBuild data-id="element-30" data-mp="3v9fplwrj2yti" />
          <FaqFinalCta data-id="element-31" data-mp="3v964amhfhfu5" />
        </main>
        <Footer data-id="element-32" data-mp="3v84m7y1zvt2x" />
        <StickyWidget data-id="element-33" data-mp="3v7l52jk658py" />
        <Diagnostic data-id="element-34" data-mp="3va2a2trcpk1" />
      </div>
    </ScoreProvider>;
}